export default {
  'Text': 'Teks',
  'Styles': 'Gaya',
  'Text here': 'Teks disini',
  'Add subtitles': 'Tambah teks',
  'Text Color': 'Warna teks',
  'Outline': 'Outline',
  'Background': 'Latar',
  'Position': 'Posisi',
}